/*
 * sdx-pdp-combo — PDP combo video + text carousel.
 * Single active slide; cross-fades video + text together.
 * Inactive videos: preload="none", paused, currentTime reset.
 * Active video: preload="auto", autoplay (muted) when enabled.
 * IntersectionObserver pauses when the section leaves the viewport.
 * prefers-reduced-motion: reduce disables autoplay.
 * Re-initialises on shopify:section:load.
 */
(function () {
  'use strict';

  var MQ_REDUCED = '(prefers-reduced-motion: reduce)';

  function init(root) {
    if (!root || root.__sdxComboInit) return;
    root.__sdxComboInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sdx-combo-slide]'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sdx-combo-dot]'));
    var prevBtn = root.querySelector('[data-sdx-combo-prev]');
    var nextBtn = root.querySelector('[data-sdx-combo-next]');

    var autoplayActive = root.dataset.autoplayActive === 'true';
    var autoAdvance = root.dataset.autoAdvance === 'true';
    var delay = parseInt(root.dataset.autoAdvanceDelay || '10000', 10);
    var reduced = window.matchMedia && window.matchMedia(MQ_REDUCED).matches;

    var index = 0;
    var timer = null;
    var visible = true;

    function videoFor(slide) {
      return slide.querySelector('[data-sdx-combo-video]');
    }

    // Upgrade a video from preload="none" to fully loaded: attach src(s).
    function hydrate(video) {
      if (!video || video.__sdxHydrated) return;
      video.__sdxHydrated = true;

      var storedSrc = video.getAttribute('data-sdx-combo-src');
      if (storedSrc && !video.getAttribute('src')) {
        video.setAttribute('src', storedSrc);
      }

      var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-sdx-combo-src]'));
      for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        if (!s.getAttribute('src')) {
          s.setAttribute('src', s.getAttribute('data-sdx-combo-src'));
        }
      }

      video.setAttribute('preload', 'auto');
      try { video.load(); } catch (e) {}
    }

    function stopVideo(video) {
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    function playVideo(video) {
      if (!video) return;
      if (!autoplayActive || reduced) return;
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* autoplay may be blocked */ });
      }
    }

    function show(next) {
      if (slides.length === 0) return;
      var target = (next + slides.length) % slides.length;
      if (target === index && slides[index].classList.contains('sdx-pdp-combo__slide--active')) {
        return;
      }

      // Deactivate current
      slides[index].classList.remove('sdx-pdp-combo__slide--active');
      slides[index].setAttribute('aria-hidden', 'true');
      stopVideo(videoFor(slides[index]));
      if (dots[index]) dots[index].setAttribute('aria-current', 'false');

      index = target;

      // Activate next
      slides[index].classList.add('sdx-pdp-combo__slide--active');
      slides[index].setAttribute('aria-hidden', 'false');
      if (dots[index]) dots[index].setAttribute('aria-current', 'true');

      var activeVid = videoFor(slides[index]);
      hydrate(activeVid);
      if (visible) playVideo(activeVid);
    }

    function goNext() { show(index + 1); }
    function goPrev() { show(index - 1); }

    function start() {
      stop();
      if (!autoAdvance || reduced) return;
      if (!visible) return;
      if (slides.length <= 1) return;
      timer = window.setInterval(goNext, delay);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Wire controls
    if (prevBtn) prevBtn.addEventListener('click', function () { goPrev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goNext(); start(); });
    for (var d = 0; d < dots.length; d++) {
      (function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index') || '0', 10);
          show(i);
          start();
        });
      })(dots[d]);
    }

    // Keyboard: left / right arrows when focus inside the section
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goPrev(); start(); }
      else if (e.key === 'ArrowRight') { goNext(); start(); }
    });

    // IntersectionObserver — pause when off-screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i];
          visible = en.isIntersecting;
          var activeVid = videoFor(slides[index]);
          if (visible) {
            hydrate(activeVid);
            playVideo(activeVid);
            start();
          } else {
            stopVideo(activeVid);
            stop();
          }
        }
      }, { threshold: 0.25 });
      io.observe(root);
    }

    // Initialise active slide
    var firstVid = videoFor(slides[index]);
    hydrate(firstVid);
    playVideo(firstVid);
    start();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sdx-pdp-combo]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor re-init
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sdx-pdp-combo]');
    if (root) {
      root.__sdxComboInit = false;
      init(root);
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-sdx-pdp-combo]');
    if (root) root.__sdxComboInit = false;
  });
})();
